export const meta: BlockMeta = {
  title: "CTAs Item",
}

import { Button } from "@components/ui/Button"
import { IconChevronRight } from "@components/ui/Icon"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/ctas-item", (props) => {
  return (
    <div className="w-full mb-2" data-ctas-item>
      <Button
        size="lg"
        href={props.link?.url}
        target={props.link?.target || undefined}
        className="!w-full !type-title-l !normal-case !justify-between !p-5 !h-auto md:[&_svg]:hover:!opacity-100"
        rightIcon={<IconChevronRight className="!w-[0.75em] !h-[0.75em] opacity-0 transition-opacity" />}
      >
        <EditableText store="cta" as="span" defaultValue="Example CTA" plainText />
      </Button>
    </div>
  )
})
